// extracted by mini-css-extract-plugin
export default {"authLayout":"style_authLayout__oWpWM","banner":"style_banner__C6jW0","content":"style_content__nmh9I","logo":"style_logo__PRyPk","items":"style_items__bBufK"};